import { CloudFrameStack } from "@cloudframe/stack";
import Authorization from "../components/auth/authorization";
import { UserPermission } from "../constants/permissions.constants";
import ContinuumScannerNotificationSettings from "../components/continuum-scanner-license/continuum-scanner-notification-settings";

const ContinuumScannerNotificationSettingsPage = () => {
  return (
    <Authorization>
      <section key={UserPermission.P_CONTINUUM_SCANNER_LICENSE}>
        <div style={{ margin: 16 }}>
          <CloudFrameStack>
            <ContinuumScannerNotificationSettings />
          </CloudFrameStack>
        </div>
      </section>
    </Authorization>
  );
};

export default ContinuumScannerNotificationSettingsPage;
